@if (housekeepingReport.rollAwayBedSummaries?.length > 0) {
  <p-table
    [value]="housekeepingReport.rollAwayBedSummaries"
    styleClass="p-datatable-sm"
    [style]="{'font-size':'12px'}">
    <ng-template pTemplate="header">
      <tr>
        <th>Unit</th>
        <th>PickUp</th>
        <th>Drop</th>
        <th>Occupied</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rollAwayBedLocation>
      <tr>
        <td>{{ rollAwayBedLocation.propertyCode }}</td>
        <td>{{ rollAwayBedLocation.checkout ? rollAwayBedLocation.qty : '' }}</td>
        <td>{{ rollAwayBedLocation.checkin ? rollAwayBedLocation.qty : '' }}</td>
        <td>{{ rollAwayBedLocation.occupied ? rollAwayBedLocation.qty : '' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td><strong>Total</strong></td>
        <td>{{ housekeepingReport.totalRollAwayPickUp }}</td>
        <td>{{ housekeepingReport.totalRollAwayDropOff }}</td>
        <td>{{ housekeepingReport.totalRollAwayOccupied }}</td>
      </tr>
    </ng-template>
  </p-table>
}
